export default __webpack_public_path__ + "854bd664031910755c374f1ef9db75c5.png";